// extracted by mini-css-extract-plugin
export default {"homeContentContainer":"HomeContent_homeContentContainer__V4qZp"};